module.exports = __webpack_public_path__ + "static/media/chicagoBears.3ffd1a7a.png";